import React, { useState, useCallback } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import NavigationBar from "../Components/NavigationBar";
import Footer from "../Components/Footer";
import "../CSS/LoginSignup.css";
// eslint-disable-next-line
import { app, db } from "../Fileconfigsettings/firebaseconfig";

const App = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const [errorData, setErrorData] = useState("");
  const [isError, setErrorStatus] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });

  const handleInputs = useCallback((event) => {
    const { name, value } = event.target;
    setData((prevData) => ({ ...prevData, [name]: value }));
  }, []);

  const isLoginDisabled = !data.email || !data.password;

  const signIn = async () => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, data.email, data.password);
      const userDocRef = doc(db, "users", userCredential.user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (userDocSnap.exists()) {
        const userData = userDocSnap.data();
        console.log(userData);
        localStorage.setItem("UserName", userData.name);
        localStorage.setItem("UserMobile", userData.mobileNumber);
        localStorage.setItem("UserEmail", userData.email);
      } else {
        console.log("User document not found.");
      }

      navigate("/");
    } catch (error) {
      setErrorStatus(true);
      setErrorData(error.message);
    }
  };

  const ErrorMessage = () => {
    if (errorData === "Firebase: Error (auth/network-request-failed).") {
      return "Network error";
    } else {
      return "Invalid username or password";
    }
  };

  return (
    <div className="WrapperMain">
      <HelmetProvider>
        <Helmet>
          <title>Login - BlogWiki</title>
          <meta name="description" content="Login to your BlogWiki account to access personalized content and features." />
        </Helmet>
      </HelmetProvider>
      <NavigationBar />
      <h2>Welcome back to BlogWiki</h2>
      <div className="FormWrapper">
        <div className="MainWrapper">
          <h2 className="loginHead">LOGIN</h2>
          <form>
            <div className="EmailWrap">
              <label htmlFor="email">Email</label>
              <input
                placeholder="Email"
                name="email"
                type="email"
                className="Emailfield"
                onChange={handleInputs}
              />
            </div>
            <div className="PasswordWrap">
              <label htmlFor="password">Password</label>
              <input
                placeholder="Password"
                name="password"
                type="password"
                className="Passwordfield"
                onChange={handleInputs}
              />
            </div>
          </form>
          <div className="LoginWrap">
            <button
              onClick={signIn}
              className={`loginBtn ${isLoginDisabled ? "disabled" : ""}`}
              disabled={isLoginDisabled}
            >
              LOGIN
            </button>
          </div>
          {isError && <p className="Errortag">*{ErrorMessage()}</p>}
          <div className="LoginSignUpWrap">
            <p>
              Don't have an account?{" "}
              <Link className="LoginSignuplink" to="/Signup">
                SignUp
              </Link>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;
